// ─── Funnel analytics (GA4) ───────────────────────────────────────────────────
// One helper, one list of event names, so the funnel in GA reads the same as
// the plan (YOGASTAY_IMPROVEMENT_PLAN.md, Phase 2 · M1).
//
// Consent: public/index.html sets analytics_storage to "denied" until the
// visitor clicks Accept in the cookie banner. Calling track() is always safe —
// GA decides what it may record — so call sites never check consent.
//
// Debugging: add ?ga_debug=1 to any URL (remembered for the session). Events
// are then logged to the console and sent with debug_mode, so they appear in
// GA → Admin → DebugView.

export const EVENTS = Object.freeze({
  HOME_VIEW: "home_view",
  QUIZ_STARTED: "quiz_started",
  QUIZ_COMPLETED: "quiz_completed",
  CONCIERGE_SUBMITTED: "concierge_submitted",
  SEARCH_SUBMITTED: "search_submitted",
  SCHOOL_CARD_CLICKED: "school_card_clicked",
  PROGRAM_VIEWED: "program_viewed",
  BOOKING_REQUEST_STARTED: "booking_request_started",
  BOOKING_REQUEST_REVIEWED: "booking_request_reviewed",
  BOOKING_REQUEST_SUBMITTED: "booking_request_submitted",
  SCHOOL_SIGNUP_STARTED: "school_signup_started",
  ONBOARDING_STEP_COMPLETED: "onboarding_step_completed",
  // Teacher Training (Phase B) — each with country and city parameters.
  YTT_SEARCH: "ytt_search",
  YTT_FILTER_APPLIED: "ytt_filter_applied",
  YTT_CARD_CLICKED: "ytt_card_clicked",
  YTT_REQUEST_STARTED: "ytt_request_started",
});

const KNOWN = new Set(Object.values(EVENTS));

function debugOn() {
  try {
    if (/[?&]ga_debug=1\b/.test(window.location.search)) sessionStorage.setItem("ys_ga_debug", "1");
    return sessionStorage.getItem("ys_ga_debug") === "1";
  } catch { return false; }
}

/** Send one funnel event. Params: short snake_case keys, no personal data. */
export function track(name, params = {}) {
  if (!KNOWN.has(name) && process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(`[analytics] unknown event "${name}" — add it to EVENTS`);
  }
  const debug = debugOn();
  const payload = debug ? { ...params, debug_mode: true } : params;
  if (debug) {
    // eslint-disable-next-line no-console
    console.info("[analytics]", name, payload);
  }
  try { window.gtag?.("event", name, payload); } catch { /* never break the UI */ }
}
